import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "../../axios";
import { ObjectToArray } from "../helper/misc";
import { route } from './routes';


// get All Product with filter
export function useAllProductList(payload) {
  const { keys } = ObjectToArray(payload);
  return useQuery([route.GET_ALL_PRODUCT_LIST, ...keys], async () => {
    const { data } = await axios.post(route.GET_ALL_PRODUCT_LIST, payload);
    return data;
  })
}


// get product details by id
export function useProductDetails({ id }) {
  return useQuery([route.GET_PRODUCT_DETAILS, id], async () => {
    const { data } = await axios.get(`${route.GET_PRODUCT_DETAILS}/${id}`);
    return data;
  }, {
    enabled: id ? true : false
  })
} 

// Check Slug Availavility
export function useCheckSlugAvailability() {
  // { slug, id }
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.CHECK_SLUG_AVAILAVILITY}`, payload);
    return data;
  })
}


export function useProductImageProcess() {
  // { slug, id }
  return useMutation(async (id) => {
    const { data } = await axios.get(`${route.PRODUCT_IMAGE_PROCESS}/${id}`);
    return data;
  })
}

export function useProductStatusChange() {
  const queryClient = useQueryClient();
  
  return useMutation(async ({ id, status, payload }) => {
    const { keys } = ObjectToArray(payload);
    const { data } = await axios.get(`${route.CHANGE_PRODUCT_CHANGE}/${id}/${status}`);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST, ...keys]);
    return data;
  })
}


export function useImageProcessList({ page, limit }) {
  return useQuery([route.PRODUCT_IMAGE_PROCESS_LIST, page, limit], async () => {
    const { data } = await axios.get(`${route.PRODUCT_IMAGE_PROCESS_LIST}`, {
      params: {
        page,
        limit
      }
    });
    return data;
  }, {
    refetchInterval: 3000
  })
}

export function useProcessRemaingCount() {
  return useQuery([route.PROCESS_REMAINING_COUNT], async () => {
    const { data } = await axios.get(`${route.PROCESS_REMAINING_COUNT}`, );
    return data;
  }, {
    refetchInterval: 3000
  })
}

export function useProcessTodayProcCount() {
  return useQuery([route.TODAY_IMAGE_PROCESSED], async () => {
    const { data } = await axios.get(`${route.TODAY_IMAGE_PROCESSED}`, );
    return data;
  }, {
    refetchInterval: 3000
  })
}



export function useProcAllVendorProdPhoto() {
  return useMutation(async ({ id }) => {
    const { data } = await axios.get(`${route.ALL_PRODUCT_PHOTO_PROCESS}/${id}`);
    return data;
  })
}
export function useImageReProcess() {
  return useMutation(async ({ id }) => {
    const { data } = await axios.get(`${route.PHOTO_RE_PROCESS}/${id}`);
    return data;
  })
}

export function useRemoveErrorImg() {
  return useMutation(async ({ id }) => {
    const { data } = await axios.get(`${route.REMOVE_PROCESSED_IMAGE}/${id}`);
    return data;
  })
}


// change_product_delivery
export function useChangeProductFreeDeliveryStatus() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, status, payload }) => {
    const { keys } = ObjectToArray(payload);
    const { data } = await axios.get(`${route.CHANGE_FREE_DELIVERY_STATUS}/${id}/${status}`);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST, ...keys]);
    return data;
  });
}

export function useMakeProductFeatured() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, payload }) => {
    const { keys } = ObjectToArray(payload);
    const { data } = await axios.get(`${route.MAKE_FEATURED_PRODUCT}/${id}`);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST, ...keys]);
    return data;
  })
}

export function useMakeMallProduct() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, payload }) => {
    const { keys } = ObjectToArray(payload);
    const { data } = await axios.get(`${route.MAKE_MALL_PRODUCT}/${id}`);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST, ...keys]);
    return data;
  })
}

export function useRemoveMallProduct() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, payload }) => {
    const { keys } = ObjectToArray(payload);
    const { data } = await axios.get(`${route.REMOVE_MALL_PRODUCT}/${id}`);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST, ...keys]);
    return data;
  })
}

// Soft-delete an explicit list of product ids
export function useDeleteProducts() {
  const queryClient = useQueryClient();
  return useMutation(async (ids) => {
    const { data } = await axios.post(route.DELETE_PRODUCTS, { ids });
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST]);
    return data;
  })
}

// Soft-delete every currently stock-out product in one shot
export function useDeleteStockOutProducts() {
  const queryClient = useQueryClient();
  return useMutation(async () => {
    const { data } = await axios.post(route.DELETE_STOCK_OUT_PRODUCTS);
    queryClient.invalidateQueries([route.GET_ALL_PRODUCT_LIST]);
    return data;
  })
}

//  Add to sale product list
export function useAddToSalesList() {
  return useQuery([route.GET_SALES_CAMPAIGN_LIST], async () => {
    const { data } = await axios.get(route.GET_SALES_CAMPAIGN_LIST);
    return data;
  })
}


export function useAddToSalesProduct() {
  return useMutation(async ({ product_id, sale_id }) => {
    const { data } = await axios.get(`${route.SET_SALES_CAMPAIGN_TO_PRODUCT}/${product_id}/${sale_id}`);
    return data;
  })

}